import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import React, {useState} from "react";
import LoadingSpinner from "../LoadingSpinner";
import {useAppSelector} from "../../redux/hooks";
import {FaArrowLeft} from "react-icons/fa";
import { useAppDispatch } from "../../redux/hooks";
import {verifyEmail, verifyPhoneNumber} from "../../redux/selfService/selfServiceSlice";
import Modal from "../Base/Modal";
import {bool} from "yup";
import {urlify} from "../../utils";

interface PropsI {
    showModal: boolean;
    onClose: ()=>void;
    onSuccess: ()=>void;

}

const RecaptureModal = ({ onClose, onSuccess, showModal }: PropsI)=>{
    const [showRecaptureLink, setShowRecaptureLink] = useState(false)
    const dispatch = useAppDispatch();
    const { isLoading, isSuccessful, recaptureLink } = useAppSelector((state) => state?.selfService);
    // const recaptureLink = ""


    return (
        <Modal showModal={showModal} onClose={onClose} >
            {!showRecaptureLink ?
                <div>
                    <h1 className="text-xl text-center mb-16">
                        You need to recapture to continue
                    </h1>


                    <button
                        onClick={() => setShowRecaptureLink(true)}
                        className="btn btn-primary btn-primary-full"
                        disabled={isLoading}
                    >
                        {isLoading ?
                            <LoadingSpinner color={"#305F32"} backgroundColor={""}/>
                            : "Continue"
                        }
                    </button>
                </div>
                :
                <div className="w-full w-max-[450px]">
                    <h1 dangerouslySetInnerHTML={{__html: urlify(recaptureLink)}}></h1>
                    <div className="text-center">
                        <button
                            onClick={onSuccess}
                            className="btn btn-primary"
                        >
                            Done Continue
                        </button>
                    </div>
                </div>
            }
        </Modal>
    );
}

export default RecaptureModal;